/**
 * Vorschau je Angebot (Entscheidung 11): gespeicherte Sollfassung vom Server, im selben Sandbox-iframe wie die Editoren.
 * Ausdrücklich gekennzeichnet: nicht die aktuelle Beschreibung bei eBay. Geladen erst beim Öffnen. Seit 31.10.2026 mit
 * den Angeboten wieder offen (Flori, nur lesend).
 */
import { Alert, Button, Loader, Modal, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { ApiRequestError } from '../api/client.js';
import { useServices } from '../services.js';
import { dateTime, t } from '../texts.js';
import { Preview } from './render-preview.js';

export function ItemPreviewButton({ tenantId, ebayItemId }: { tenantId: string; ebayItemId: string }) {
  const { api } = useServices();
  const [open, setOpen] = useState(false);
  const query = useQuery({ queryKey: ['item-preview', tenantId, ebayItemId], queryFn: () => api.itemPreview(tenantId, ebayItemId), enabled: open, retry: false });
  return (
    <>
      <Button size="compact-xs" variant="subtle" onClick={() => setOpen(true)} aria-label={`${t('itemPreview.open')}: ${ebayItemId}`}>
        {t('itemPreview.open')}
      </Button>
      <Modal opened={open} onClose={() => setOpen(false)} title={t('itemPreview.title')} size="xl">
        {/* Beim erneuten Öffnen lädt die Vorschau neu; bis dahin nie die alte Fassung zeigen. */}
        {query.isPending || query.isFetching ? (
          <Loader size="sm" />
        ) : query.isError ? (
          <Alert color="yellow" role="alert">
            {query.error instanceof ApiRequestError && query.error.detail ? query.error.detail : t('common.error')}
          </Alert>
        ) : (
          <Preview result={{ html: query.data.html, warnings: query.data.warnings }}>
            <Text size="xs" c="dimmed">
              {t('itemPreview.stored', { article: query.data.articleVersion, design: query.data.designVersion, date: dateTime(query.data.observedAt) })}
            </Text>
          </Preview>
        )}
      </Modal>
    </>
  );
}
